(function($) {
	$('#up').on('click', function() {
		$('html').animate({ scrollTop: 0 }, 500);
	});
})(jQuery);